export const ApiSettingsMailDesign = (axios, obuBaseUrl) => {
  axios.setBaseURL(obuBaseUrl)

  const load = async () => {
    const result = await axios.get('api/settings/mail-design/')
    return result.data
  }

  const find = async (id) => {
    const result = await axios.get(`api/settings/mail-design/${id}`)
    return result.data
  }

  const remove = async (id) => {
    const result = await axios.delete(`api/settings/mail-design/${id}`)
    return result.data
  }

  const save = async (id, payload) => {
    const result = await axios.post(`api/settings/mail-design/${id}`, payload)
    return result.data
  }

  return {
    mailDesignsFind: find,
    mailDesignsLoad: load,
    mailDesignsRemove: remove,
    mailDesignsSave: save
  }
}
